import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { TradingProcedureDocumentResponseDto } from '../schemas/trading-procedure-document-response.dto';
import { TradingProcedureRegistryInfoResponseDto } from '../schemas/trading-procedure-registry-info-response.dto';
import { TRADGINE_DATA_API_BASE_URL } from '../api-base-url.token';

@Injectable({ providedIn: 'root' })
export class TradingProcedureDocumentApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(TRADGINE_DATA_API_BASE_URL)}/TradingProcedureDocument`;

    getAll(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/GetAll`)
            .get()
            .json<TradingProcedureDocumentResponseDto[]>()
            .withHttpParams(new HttpParams().set('tradingProcedureId', tradingProcedureId))
            .build()
            .send();
    }

    getById(tradingProcedureDocumentId: number) {
        return this.builder
            .url(`${this.controllerUrl}/GetById`)
            .get()
            .json<TradingProcedureDocumentResponseDto>()
            .withHttpParams(new HttpParams().set('id', tradingProcedureDocumentId))
            .build()
            .send();
    }

    getRegistryInfo(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/GetRegistryInfo`)
            .get()
            .json<TradingProcedureRegistryInfoResponseDto>()
            .withHttpParams(new HttpParams().set('tradingProcedureId', tradingProcedureId))
            .build()
            .send();
    }

    getRegistry(tradingProcedureId: number) {
        return this.builder
            .url(`${this.controllerUrl}/GetRegistry`)
            .get()
            .blob()
            .withHttpParams(new HttpParams().set('tradingProcedureId', tradingProcedureId))
            .build()
            .send();
    }
}
